import { Component } from '@angular/core';
import { Note, NoteProvider } from '@stuplay';
import { StorageService } from '../../services/storage.service';

@Component({
    selector: 'msc-note',
    templateUrl: './note.component.html'
})

export class NoteComponent {
    currentNote: Note;
    notes: any[];
    templateId: number;
    showCreateForm: boolean = false;
    newNoteName: string = '';

    constructor(
        private noteProvider: NoteProvider,
        private storageService: StorageService,
    ) {
        this.templateId = this.storageService.get('course')?.id
    }

    ngOnInit() {
        this.templateId = this.storageService.get('course')?.id
        this.noteProvider.getNotes(this.templateId).subscribe((notes: Note[]) => this.notes = notes);
    }

    toggleCreateForm(): void {
        this.showCreateForm = !this.showCreateForm;
        if (!this.showCreateForm) {
            this.newNoteName = '';
        }
    }

    setCurrentNote(note: any): void {
        this.currentNote = note;
    }

    resetCurrentNote(): void {
        this.currentNote = null;
    }

    createNote(): void {
        if (!this.newNoteName.trim()) { return; }
        this.noteProvider.createNote(this.templateId).subscribe((note) => {
            note.name = this.newNoteName.trim();
            note.update().subscribe();
            this.notes.push(note);
            this.newNoteName = '';
            this.showCreateForm = false;
            this.currentNote = note;
        });
    }

    deleteNote(note: any): void {
        note.delete(note?.id).subscribe(() => {
            this.notes.splice(this.notes.indexOf(note), 1);
        });
    }
}
